export default function hasNoWindow() {
  return typeof window === 'undefined';
}
